import P from 'components/P';
import Container from 'layouts/container/Container';
import FlexChild from 'layouts/flex/FlexChild';
import HorizontalFlex from 'layouts/flex/HorizontalFlex';
import VerticalFlex from 'layouts/flex/VerticalFlex';
import React, { useEffect, useState } from 'react';
import LineChart from 'routes/vendorRe/components/LineChart';
import { requester } from 'App';
import OrderStatus from 'routes/admin/dashboardCard/statistics/OrderStatus';
import DelayStatistics from 'routes/admin/dashboardCard/statistics/DelayStatistics';
import StoreSalesStatistics from 'routes/admin/dashboardCard/statistics/StoreSalesStatistics';
import OrderCalc from 'routes/admin/dashboardCard/order/OrderCalc';
import WorkSharing from 'routes/admin/dashboardCard/work/WorkSharing';
import Notice from 'routes/admin/dashboardCard/notice/Notice';
import Manual from 'routes/admin/dashboardCard/manual/Manual';
import StatisticsExchangeAndRefund from 'routes/admin/dashboardCard/statistics/StatisticsExchangeAndRefund';
import styles from './PartnersDashboard.module.css';



function PartnersDashboard() {
    const [isMounted, setMounted] = useState(false);
    const [totalWeekEachAmount, setTotalWeekEachAmount] = useState();
    const [totalSalesAmount, setTotalSalesAmount] = useState();
    const [verificationStats, setVerificationStats] = useState([]);



    useEffect(() => {
        setMounted(true);
    }, [])
    useEffect(() => {
        if (isMounted) {
            let storeData = {}; //임시(나중에 인증 인가에 활용할 예정)
            requester.getWeeklyTotalSalesStatus({}, (result) => {
                setTotalWeekEachAmount(result.data);
                console.log("getWeeklyTotalSalesStatus : ",result.data)
            })

            requester.getStoresSalesSummary({}, (result) => {
                setTotalSalesAmount(result.data);
                console.log("getStoresSalesSummary : ",result.data)
            })

            requester.partnersAdultVerificationStats("", result => {
                if (result.data) {
                    setVerificationStats(result.data);
                    console.log("setVerificationStats : ", result.data);
                }
            })

        }
    }, [isMounted])

    return (
        <Container width={"100%"} maxWidth={"100%"}>
            <VerticalFlex margin={20} gap={20} width={"100%"}>
                {/* 대시보드 상단 섹션 - 그리드 레이아웃 */}
                <FlexChild>
                    <HorizontalFlex gap={20} justifyContent={"flex-start"} alignItems={"stretch"}>
                        {/* 주간 총 매출현황 카드 */}
                        <FlexChild width={"60%"} backgroundColor={"white"} borderRadius={"10px"} padding={"20px"}>
                            <VerticalFlex gap={15} height={"100%"}>
                                <FlexChild justifyContent={"flex-start"}>
                                    <P weight={700} size={"22px"}>주간 총 매출현황</P>
                                </FlexChild>
                                <FlexChild flex={1}>
                                    <LineChart totalWeekEachAmount={totalWeekEachAmount} />
                                </FlexChild>
                            </VerticalFlex>
                        </FlexChild>

                        {/* 정산 금액 조회 카드 */}
                        <FlexChild width={"30%"} backgroundColor={"white"} borderRadius={"10px"}>
                            <OrderCalc web />
                        </FlexChild>

                    </HorizontalFlex>
                </FlexChild>

                {/* 대시보드 하단 섹션 */}
                <FlexChild>
                    <HorizontalFlex gap={20} justifyContent={"flex-start"} alignItems={"stretch"}>
                        {/* 매장별 매출현황 카드 */}
                        <FlexChild width={"60%"} backgroundColor={"white"} borderRadius={"10px"} padding={"20px"}>
                            <VerticalFlex gap={15} height={"100%"}>
                                <FlexChild justifyContent={"flex-start"} height={"fit-content"}>
                                    <P weight={700} size={"22px"}>매장별 매출현황</P>
                                </FlexChild>
                                <FlexChild flex={1}>
                                    <StoreSalesStatistics totalSalesAmount={totalSalesAmount} />
                                </FlexChild>
                            </VerticalFlex>
                        </FlexChild>

                        {/* 추가 대시보드 항목 (오른쪽 공간) */}
                        {/* 매장별 통계 */}
                        <FlexChild width={"30%"} backgroundColor={"transparent"}>
                            <div className={styles.statsCard}>
                                <div className={styles.statsHeader}>
                                    <h2 className={styles.statsTitle}>매장별 성인인증 통계</h2>
                                    {/* <span
                                        className={styles.moreLink}
                                        onClick={() => navigate('/admin/verificationStats')}
                                    >
                                        더보기 {'>'}
                                    </span> */}
                                </div>
                                {Array.isArray(verificationStats) && verificationStats.slice(0, 3).map((store) => (
                                    <div key={store.storeCode} className={styles.storeCard}>
                                        <div className={styles.storeName}>{store.storeName}</div>
                                        <div className={styles.storeStats}>
                                            <div className={styles.statItem}>
                                                <div className={styles.statLabel}>총 시도</div>
                                                <div className={styles.statValue}>
                                                    {store.totalCount}
                                                </div>
                                            </div>
                                            <div className={styles.statItem}>
                                                <div className={styles.statLabel}>PASS인증</div>
                                                <div className={`${styles.statValue} ${styles.green}`}>
                                                    {store.passCount}
                                                </div>
                                            </div>
                                            <div className={styles.statItem}>
                                                <div className={styles.statLabel}>SMS인증</div>
                                                <div className={`${styles.statValue} ${styles.blue}`}>
                                                    {store.smsCount}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </FlexChild>
                    </HorizontalFlex>
                </FlexChild>
            </VerticalFlex>
        </Container>
    );
};

export default PartnersDashboard;